"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var SpinnerContainer = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: ", "px;\n  height: ", "px;\n  box-sizing: border-box;\n"])), function (props) {
  return props.size || 40;
}, function (props) {
  return props.size || 40;
});
var SpinnerCircle = _styledComponents.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  border: ", "px solid rgba(243, 243, 243, 0.8);\n  border-top: ", "px solid var(--muted-foreground);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"])), function (props) {
  return Math.max(1, Math.floor((props.size || 40) / 20));
}, function (props) {
  return Math.max(1, Math.floor((props.size || 40) / 20));
});
var Spinner = function Spinner(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SpinnerContainer, {
    size: size,
    "data-sentry-element": "SpinnerContainer",
    "data-sentry-component": "Spinner",
    "data-sentry-source-file": "Spinner.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SpinnerCircle, {
      size: size,
      "data-sentry-element": "SpinnerCircle",
      "data-sentry-source-file": "Spinner.tsx"
    })
  });
};
var _default = exports.default = Spinner;